import React, { useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import { Radio } from 'antd';
import { UnorderedListOutlined, BarChartOutlined } from '@ant-design/icons';
import GanttView from '../ShiftBat/GanttView';
import './Rosters.css';
import useBlocksAsShiftBats from '../../hooks/useBlocksAsShiftBats';
import { useAppContext } from '../../libs/contextLib';
const Blocks = () => {
  const { setPageTitle } = useAppContext();
  const [viewMode, setViewMode] = useState('gantt');
  const [sortBy, setSortBy] = useState('code');
  const { shiftBats } = useBlocksAsShiftBats();

  return (
    <Container fluid className="roster-container">
      <Card className="roster-card">
        <Card.Header className="roster-header">
          <div className="d-flex justify-content-between align-items-center">
            <h2>Vehicle Blocks</h2>
            <Radio.Group 
              value={viewMode} 
              onChange={e => setViewMode(e.target.value)}
              buttonStyle="solid"
              className="view-mode-toggle"
            >
              <Radio.Button value="list">
                <UnorderedListOutlined /> List
              </Radio.Button>
              <Radio.Button value="gantt">
                <BarChartOutlined /> Gantt
              </Radio.Button>
            </Radio.Group>
          </div>
        </Card.Header>
        <Card.Body>
          {viewMode === 'list' ? (
            <div>List view will be implemented here</div>
          ) : (
            <GanttView 
              shiftBats={shiftBats}
              onSearch={() => {}}
              sortBy={sortBy}
              setSortBy={setSortBy}
              ganttTitle="Block"
            />
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Blocks; 